import React, { Component } from "react";
import { connect } from 'react-redux';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { AiOutlineDelete } from "react-icons/ai";
import { FiEdit2 } from "react-icons/fi";
import { MdKeyboardArrowUp, MdKeyboardArrowDown } from 'react-icons/md';
import * as formActions from '../../../Redux/Actions/form';

const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    result.filter(res => res !== null);
    return result;
};

class ReOrderServiceCards extends Component {

    constructor(props) {
        super(props);
        this.onDragEnd = this.onDragEnd.bind(this);
        this.state = {
            openCardID: ''
        };
    }
    
    onDragEnd = (result) => {
        if (!result.destination) {
            return;
        }
    
        const data = reorder(
            this.props.serviceCards,
            result.source.index,
            result.destination.index
        );
        this.props.reArrangeServiceCard(data);
    };

    handlePreviewAccordion = (id) => {
        const { openCardID } = this.state;
        this.setState({
            openCardID: (openCardID === id) ? '' : id
        });
    };

    handleRemoveServiceCard = (title, id) => {
        return window.confirm(`Have you want to delete ${title} service card ?`) ? this.props.deleteServiceCard(title, id) : '';
    };

    render () {
        const { serviceCards, isArabic, editServiceCard } = this.props;
        const { openCardID } = this.state;
        return(
            <DragDropContext onDragEnd={this.onDragEnd}>
                <Droppable droppableId="droppable">
                    {(provided, snapshot) => (
                        <div {...provided.droppableProps} ref={provided.innerRef}>
                            {serviceCards && serviceCards.map(({title, description, arabicTitle, arabicDescription}, index) => 
                                <Draggable key={title+'_'+index} draggableId={title+'_'+index} index={index}>
                                    {(provided, snapshot) => (
                                        <div ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
                                            <div className="accordion accordion-light accordion-toggle-arrow cursor-default" key={index} isDragging={snapshot.isDragging}>
                                                <div className="bg-white p-5 mb-5">
                                                    <div className={"d-flex justify-content-between card-title m-0 " + ((openCardID === index) ? "" : "collapsed ") + (isArabic ? "flex-row-reverse" : "flex-row")}>
                                                        <span style={{fontSize: 13, color: '#121180'}} className="cursor-pointer" onClick={() => this.handlePreviewAccordion(index)}>{isArabic ? arabicTitle : title}</span>
                                                        <div className="d-flex">
                                                            <FiEdit2 className="cursor-pointer mr-5" onClick={() => editServiceCard({id: index, title, description, arabicTitle, arabicDescription})} />
                                                            <AiOutlineDelete className="cursor-pointer mr-5" onClick={() => this.handleRemoveServiceCard(title, index)} />
                                                            <span className="cursor-pointer d-flex" onClick={() => this.handlePreviewAccordion(index)}>
                                                                {(openCardID === index) ? <MdKeyboardArrowUp /> : <MdKeyboardArrowDown />}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className={"collapse " + ((openCardID === index) ? "show" : "")}>
                                                    <div className={"card-body pt-0 " + (isArabic ? "text-right" : "text-left")} dir={isArabic ? 'rtl' : 'ltr'} dangerouslySetInnerHTML={{__html: (isArabic ? arabicDescription : description)}} />
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </Draggable>
                            )}
                            {provided.placeholder}
                        </div>
                    )}
                </Droppable>
            </DragDropContext>
        );
    };
};

const mapStateToProps = ({Form}) => ({
    serviceCards: Form.serviceCards
});

const mapDispatchToProps = (dispatch) => ({
    editServiceCard: (id, title, description, arabicTitle, arabicDescription) => dispatch(formActions.editServiceCard(id, title, description, arabicTitle, arabicDescription)),
    reArrangeServiceCard: (data) => dispatch(formActions.reArrangeServiceCard(data)),
    deleteServiceCard: (title, id) => dispatch(formActions.deleteServiceCard(title, id))
});

export default connect(mapStateToProps, mapDispatchToProps)(ReOrderServiceCards);